// extracted by mini-css-extract-plugin
export default {"iconsContainer":"MrfbJPkdopJRhHD388f5","large":"Qbiy8JzcfCVsbxI_RUQK","medium":"zevWSmzCDvN_o5kbNdxt"};